import * as Yup from 'yup';

const memberSchema = Yup.object().shape({
  email: Yup.string().email('Invalid email').required('Email is required'),
  name: Yup.string()
    .required('Name is required')
    .max(255, 'Name is too long (max 255 characters)'),
  position: Yup.string()
    .required('Position is required')
    .max(72, 'Position is too long (max 72 characters)'),
  role: Yup.string().required('Role is required'),
});

const getTruncatedText = (isUpTablet: boolean, text: string) => {
  if (isUpTablet) {
    return text;
  }
  if (text.length > 20) {
    return `${text.slice(0, 20)}...`;
  }
  return text;
};

export { memberSchema, getTruncatedText };
